// NOTE: we explicitly import vue to use $copy and other functions
import Vue from 'vue'
// NOTE: we use lodash for deep object manipulation
import _ from 'lodash';
const state = {
    loadingModule:[],
    saving: false,
    styleOptions: {
        colorSchemes: {
			"red": {
			    0: "103, 0, 0", // Headings/Button 1 MAIN COLOR
			    1: "255, 255, 255", // Heading Fonts WHITE
			    2: "0, 0, 0", // Body Fonts BLACK
			    3: "156, 27, 21", // Menu SECONDARY COLOR
			    4: "197, 197, 197", // Background LIGHT GREY
			    5: "117, 117, 117",  // Button DARK GREY
			},
			"orange": {
			    0: "255, 145, 4",
			    1: "255, 255, 255",
			    2: "0, 0, 0",
			    3: "32, 79, 87",
				4: "197, 197, 197", // Background LIGHT GREY
			    5: "117, 117, 117",  // Button DARK GREY
			},
			"gold": {
			    0: "204, 152, 0",
			    1: "255, 255, 255",
			    2: "0, 0, 0",
			    3: "2, 55, 105",
				4: "197, 197, 197", // Background LIGHT GREY
			    5: "117, 117, 117",  // Button DARK GREY
			},
			"green": {
			    0: "39, 76, 1",
			    1: "255, 255, 255",
			    2: "0, 0, 0",
			    3: "150, 150, 95",
				4: "197, 197, 197", // Background LIGHT GREY
			    5: "117, 117, 117",  // Button DARK GREY
			},
			"blue": {
			    0: "0, 49, 111",
			    1: "255, 255, 255",
			    2: "0, 0, 0",
			    3: "157, 30, 20",
				4: "197, 197, 197", // Background LIGHT GREY
				   	5: "117, 117, 117",  // Button DARK GREY
			},
			"black": {
			    0: "0, 0, 0",
			    1: "255, 255, 255",
			    2: "0, 0, 0",
			    3: "72, 72, 72",
				4: "197, 197, 197", // Background LIGHT GREY
			    5: "117, 117, 117",  // Button DARK GREY
			},
			"brown": {
			    0: "167, 126, 82",
			    1: "255, 255, 255",
			    2: "0, 0, 0",
			    3: "143, 77, 25",
			    4: "197, 197, 197",
			    5: "53, 39, 30",
			}
        },
        highlightFonts: {
            0: { label: 'Alfa Slab One', value: '"Alfa Slab One", cursive' },
            1: { label: 'Allerta Stencil', value: '"Allerta Stencil", sans-serif' },
            2: { label: 'Anton', value: '"Anton", sans-serif' },
            3: { label: 'Baloo Bhai', value: '"Baloo Bhai", cursive' },
            4: { label: 'Baumans', value: '"Baumans", cursive' },
            5: { label: 'Diplomata SC', value: '"Diplomata SC", cursive' },
            6: { label: 'Gravitas One', value: '"Gravitas One", cursive' },
            7: { label: 'Notable', value: '"Notable", sans-serif' },
            8: { label: 'Old Standard TT', value: 'Old Standard TT, serif' },
            9: { label: 'Orbitron', value: 'Orbitron, sans-serif' },
            10: { label: 'Prosto One', value: 'Prosto One, cursive' },
            11: { label: 'Russo One', value: 'Russo One, sans-serif' },
            12: { label: 'Rye', value: 'Rye, cursive' },
            13: { label: 'Open Sans' ,value: "'Open Sans', sans-serif" }
        },
        bodyFonts: {
            0: { label: 'Libre Baskerville', value: "'Libre Baskerville', serif" },
            1: { label: 'Abel', value: "'Abel', sans-serif" },
            2: { label: 'Open Sans' ,value: "'Open Sans', sans-serif" }
        }
    },
	template_description: null,
	template_description_copy: null,
	template_data: null,
    templateDataId: null,
	images: [],
	template_data_copy: {}
}
const mutations = {
    UPDATE_LOADING_MODULE(state, { value, remove }) {
        if (remove) {
            state.loadingModule.splice(state.loadingModule.indexOf(value), 1)
        } else if (state.loadingModule.indexOf(value) == -1) {
            state.loadingModule.push(value)
        }
    },
    UPDATE_HEADER_OPTIONS(state, obj) {
		state.template_data.headerOptions[obj.prop] = obj.value
		if (obj.prop == 'backgroundImage') {
			state.images.push(obj.value)
		}
	},
    UPDATE_SAVING(state, saving) {
		state.saving = saving
	},
    UPDATE_TEMPLATE_DESCRIPTION(state, value) {
        state.template_description = value
    },
    COPY_TEMPLATE_DATA(state) {
		state.template_description_copy = state.template_description
		state.template_data_copy = Vue.prototype.$copy(state.template_data, 'COPY_TEMPLATE_DATA')
	},
    UPDATE_PRODUCT_SECTIONS(state, value) {
        state.template_data.productSections = value
    },
    UPDATE_PRODUCT_SECTIONS_STYLES(state, obj) {
        state.template_data.productSectionsStyles = obj
    },
    UPDATE_TEMPLATE_DATA(state, { path, value }) {
		if (state.template_data) {
			// DEBUGGING
			// console.log(Vue.prototype.$copy(state.template_data, 'UPDATE_TEMPLATE_DATA'))
		}
        if (!path) {
            state.template_data = value
        } else {
			_.set(state.template_data, path, value)
			if (path.indexOf('Image') > -1 || path.indexOf('image') > -1 || path.indexOf('logo') > -1) {
				state.images.push({
					image_src: value.image_src,
					image_id: value.image_id
				})
			}
        }
	},
    REVERT_TEMPLATE_DATA(state) {
		state.template_data = Vue.prototype.$copy(state.template_data_copy, 'REVERT_TEMPLATE_DATA')
	},
    UPDATE_TEMPLATE_DATA_ID(state, value) {
        state.templateDataId = value
    },
    REMOVE_IMAGE(state, { path, image_id }) {
		_.set(state.template_data, path, { image_src: null, image_id: null })
		for (var i = 0; i < state.images.length; i++) {
			if (state.images[i]['image_id'] == image_id) {
				delete state.images[i]
				break;
			}
		}
	},
    UPDATE_COLOR_SCHEME(state, index) {
		state.template_data.siteOptions.colorScheme = index
	},
    UPDATE_PROPERTY(state, { property, value }) {
        state[property] = value
    }
}
const getters = {
    getLoadingModule: state => state.loadingModule.length > 0,
    getTemplateDescription: state => state.template_description,
    getTemplateData: state => state.template_data,
    getProductSections: state => state.template_data.productSections,
    getProductSectionsStyles: state => state.template_data.productSectionsStyles,
    getStyleOptions: state => state.styleOptions,
    getColorSchemeColors: state => state.styleOptions.colorSchemes[state.template_data.siteOptions.colorScheme],
    getColorSchemeFontColors(state) {
        return {
			0: state.styleOptions.colorSchemes[state.template_data.siteOptions.colorScheme][1],
			1: state.styleOptions.colorSchemes[state.template_data.siteOptions.colorScheme][2]
		}
    },
	getColorSchemeCountIconColors(state) {
        return {
			0: state.styleOptions.colorSchemes[state.template_data.siteOptions.colorScheme][0],
			1: state.styleOptions.colorSchemes[state.template_data.siteOptions.colorScheme][1],
			2: state.styleOptions.colorSchemes[state.template_data.siteOptions.colorScheme][2],
			3: state.styleOptions.colorSchemes[state.template_data.siteOptions.colorScheme][3],
			4: state.styleOptions.colorSchemes[state.template_data.siteOptions.colorScheme][4],
			5: state.styleOptions.colorSchemes[state.template_data.siteOptions.colorScheme][5]
		}
    },
    getHeaderOptions: state => state.template_data.headerOptions,
    getTemplateDataChanged(state) {
		return Vue.prototype.$changed(state.template_data, state.template_data_copy) || (state.template_description != state.template_description_copy)
	},
    getSaving: state => state.saving
}
const actions = {
    bootstrapModule({ state, commit, dispatch, rootState }) {
        rootState.source = 'WEBSITE'
        commit('UPDATE_LOADING_MODULE', { value: 'get_menu_recursive' })
        this.dispatch('fetchModuleNavMenu', 'WEBSITE_DASHBOARD_MENU').then(() => {
            commit('UPDATE_LOADING_MODULE', { value: 'get_menu_recursive', remove: true })
        }).catch(err => {
            commit('UPDATE_LOADING_MODULE', { value: 'get_menu_recursive', remove: true })
            console.log(err);
        })
    },
    updateLoadingModule({ commit }, { value, remove }) {
        commit('UPDATE_LOADING_MODULE', { value, remove })
    },
    updateNavMenu({ state, commit, dispatch }, value) {
        commit('UPDATE_PROPERTY', { property: 'navMenu', value: value })
    },
    removeImage({ commit }, value) {
		commit('REMOVE_IMAGE', value)
	},
    copyTemplateData({ commit }) {
		commit('COPY_TEMPLATE_DATA')
	},
    updateTemplateDescription({ commit }, value) {
		commit('UPDATE_TEMPLATE_DESCRIPTION', value)
	},
    updateTemplateData({ commit }, obj) {
		commit('UPDATE_TEMPLATE_DATA', obj)
	},
    updateTemplateDataId({ commit }, value) {
        commit('UPDATE_TEMPLATE_DATA_ID', value)
    },
    updateColorScheme({ commit }, index) {
		commit('UPDATE_COLOR_SCHEME', index)
	},
    updateHeaderOptions({ commit }, value) {
		commit('UPDATE_HEADER_OPTIONS', value)
	},
    updateProductSections({ commit }, value) {
		commit('UPDATE_PRODUCT_SECTIONS', value)
	},
	updateProductSectionsStyles({ commit }, value) {
		commit('UPDATE_PRODUCT_SECTIONS_STYLES', value)
	},
    saveTemplateData({ state, commit, dispatch }, template_id) {
		commit('UPDATE_SAVING', true)
		return new Promise((resolve, reject) => {
			var styleSheet = document.getElementById("template_styles").sheet

			var styles = ""
			_.forOwn(styleSheet.rules, (rule, index) => {
				styles += rule.cssText.replace('#website-preview', 'body') + "\n"
			})
			var data = {
				//images: state.images,
                template_id: template_id,
				template_data_id: state.templateDataId,
				template_data: Vue.prototype.$copy(state.template_data, 'saveTemplateData'),
				template_css: styles
			}
			dispatch('apiCall', { destination: 'save_site_template_data', data }, { root: true }).then(response => {
				commit('UPDATE_SAVING', false)
				if (response.status == 'error') {
					// TO-DO: alert the user that the options couldn't be saved
					reject(response)
				} else {
					commit('COPY_TEMPLATE_DATA')
					resolve()
				}
			}).catch(error => {
				commit('UPDATE_SAVING', false)
				console.log(error)
				// TO-DO: alert the user that the options couldn't be saved
				reject(error)
			})
		})
	},
	addStylesheetRules({ state, dispatch }, { parent, rules }) {
		if (!rules) return

		var styleEl = document.getElementById('template_styles');

		if (styleEl) {
			styleEl.remove()
		}
		styleEl = document.createElement('style');
		styleEl.id = "template_styles";
		styleEl.type = "text/css"
		// Append <style> element to <head>
		document.head.appendChild(styleEl);

		// Grab style element's sheet
		var styleSheet = styleEl.sheet;
		var index = 0;

		for (var i = 0; i < rules.length; i++) {
			var j = 1,
			rule = rules[i],
			selector = rule[0],
			propStr = '';
			// console.log(selector)
			if (selector == '@import') {
				// console.log(selector, rule[1])
				styleSheet.insertRule(selector + ' ' + rule[1] + ';\n', 0)
			} else {
				// If the second argument of a rule is an array of arrays, correct our variables.
				if (Array.isArray(rule[1][0])) {
					rule = rule[1];
					j = 0;
				}

				// console.log(rules[i])
				for (var pl = rule.length; j < pl; j++) {
					var prop = rule[j];
					if (prop[0] == 'position') {
						index = prop[1]
					} else if (prop[1]) {

						// prop[0]: property
						// prop[1]: value
						// prop[2]: important true/false
						propStr += prop[0] + ': ' + prop[1] + (prop[2] ? ' !important' : '') + ';\n';
					}
				}

				selector = (parent && selector != parent) ? parent + ' ' + selector : selector
				// Insert CSS Rule
				// console.log(selector + ' {' + propStr + '}')
				styleSheet.insertRule(selector + ' { ' + propStr + ' }', index);
			}
		}
		// For debugging purposes only
		var styleSheet = document.getElementById("template_styles").sheet
		// console.log(styleSheet)
		var styles = ""
		_.forOwn(styleSheet.rules, (rule, index) => {
			styles += rule.cssText + "\n"
		})
	},
	revertTemplateData({ state, commit, dispatch }) {
		commit('REVERT_TEMPLATE_DATA')
	},
}
export default {
    namespaced: true,
    state,
    mutations,
    getters,
    actions
}
